export type FounderInviteStatus =
  | 'WAITING_FOR_FOUNDER'
  | 'JOINED_WAITING_FOR_DECK'
  | 'DECK_UP'
  | 'REMOVED_BY_FOUNDER'

export interface FounderInviteRow {
  id: string
  startupName: string
  status: FounderInviteStatus
  /** The link while the invite waits for its founder: Open invite shows it again. */
  link: string | null
  createdAt: string
}

/** The invites the Invites section lists. Once the deck is up the follow is in the watchlist, so the row leaves. */
export function sectionInvites(invites: FounderInviteRow[]): FounderInviteRow[] {
  return invites.filter((invite) => invite.status !== 'DECK_UP')
}

/** Only an invite the founder has not used yet can be removed; the API refuses the rest. */
export function canRemoveInvite(status: FounderInviteStatus): boolean {
  return status === 'WAITING_FOR_FOUNDER'
}

/** A name as an invite compares it: case and spaces ignored, so "LumenGrid" and "Lumen Grid" are one startup. */
const nameKeyOf = (name: string): string => name.replace(/\s+/g, '').toLowerCase()

/** The open invite (still waiting for its founder, with its link) the investor already made for a startup, if any. */
export function openInviteFor(
  invites: FounderInviteRow[],
  startup: string
): { id: string; startup: string; link: string } | undefined {
  const key = nameKeyOf(startup)
  const invite = invites.find(
    (row) => row.status === 'WAITING_FOR_FOUNDER' && row.link && nameKeyOf(row.startupName) === key
  )
  return invite?.link
    ? { id: invite.id, startup: invite.startupName, link: invite.link }
    : undefined
}
